import Workspace from '../../actions/workspace'
import AuthService from '../../services/auth'
import UtilService from '../../services/util'

import {
    AUTH_FAILURE,
    AUTH_LOGOUT,
    AUTH_REQUEST,
    AUTH_SUCCESS
} from '..'

export default class Auth {

    /**
     * Checks if the user is authenticated and calls dispatch() with the corresponding AUTH value.
     * Called from LoginGSMPage::ComponentDidMount(). This should result in a follow-on call that will
     * call process() to complete the authentication process.
     * @returns {Promise<*>} No return value, but dispatches results.
     */
    start() {
        return (dispatch) => {
            return AuthService.authenticate()
                .then(() => {
                    dispatch({ type: AUTH_REQUEST })
                })
                .catch((error) => {
                    dispatch({
                        type: AUTH_FAILURE,
                        error
                    })
                })
        }
    }


    /**
     * Finish processing a login attempt that was kicked off by start().
     * Called from LoginGSM2Page::ComponentDidMount().
     * 
     * @param dispatch
     * @returns {Promise<*>} No return value, but dispatches results.
     */
    process() {
        return (dispatch) => {
            return AuthService.completeAuthentication()
                .then((authResult) => {
                    return AuthService.setSession(authResult)
                })
                .then((authResult) => {
                    dispatch({
                        type: AUTH_SUCCESS,
                        data: authResult
                    })
                })
                .catch((error) => {
                    dispatch({
                        type: AUTH_FAILURE,
                        error
                    })
                })
                .finally(() => {
                    return dispatch(Workspace.clear())
                })
        }
    }


    /**
     * Fetches the login session key/value pairs as previously returned by Autho0. Dispatches
     * the results. Called from the top-level source module on load (/src/index.js)
     * 
     * @returns {Promise<*>} No return value, but dispatches results.
     */
    reload() {
        return (dispatch) => {
            return AuthService.isAuthenticated()
                .then((authenticated) => {
                    if (!authenticated) {
                        dispatch({
                            type: AUTH_FAILURE,
                            error: new Error('Unable to reload authentication')
                        })
                        return
                    }
                    return AuthService.getSession()
                })
                .then((authResult) => {
                    if (!authResult) {
                        return
                    }
                    dispatch({
                        type: AUTH_SUCCESS,
                        data: authResult
                    })

                    return dispatch(Workspace.load())
                })
                .catch((error) => {
                    UtilService.safeLog(error)
                })
        }
    }


    /**
     * Logs the user out of the application. Called from logged-out-page::ComponentDidMount(), and
     * also from the app for a time-out, or explicity logout action by the user.
     *
     * @param dispatch
     * @returns {Promise<*>} No return value, but dispatches results.
     */
    logout() {
        return (dispatch) => {
            return AuthService.logout()
                .catch(() => {
                })
                .then(() => {
                    dispatch({ type: AUTH_LOGOUT })
                })
                .finally(() => {
                    return dispatch(Workspace.clear())
                })
        }
    }

}



// WEBPACK FOOTER //
// src/actions/auth/index.js